import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroCreateContactPopup.ContactInformationSection', {
    nameLabel: 'Contact name',
    namePlaceholder: 'Enter contact name',
    accountNumber: 'Account number',
    accountNumberPlaceholder: 'Enter account number',
    firstNameLabel: 'Primary person first name',
    firstNamePlaceholder: 'Enter primary person first name',
    lastNameLabel: 'Last name',
    lastNamePlaceholder: 'Enter primary person last name',
    emailLabel: 'Email',
    emailPlaceholder: 'Ex: name@email.com',
    phoneLabel: 'Phone',
    faxLabel: 'Fax',
    mobileLabel: 'Mobile',
    directDialLabel: 'Direct dial',
    skypeNameLabel: 'Skype name/number',
    skypeNamePlaceholder: 'Enter Skype name/number',
    websiteLabel: 'Website',
    websitePlaceholder: 'Ex: http://approvalmax.com',
});
